module.exports = __webpack_public_path__ + "static/media/member-detail.3a64b2f3.png";